import { apiGet, apiPost, apiSend } from './api';
import type { PayPreset } from './deals-api';

// ---- Цеха (переименование в «Настройках») ----
export type CehRow = { id: string; name: string; descr: string | null; sort: number };
export const getCehsAdmin = () => apiGet<{ cehs: CehRow[] }>('/api/cehs');
export const updateCeh = (id: string, name: string, descr: string) =>
  apiSend<{ ok: boolean }>('PATCH', `/api/cehs/${id}`, { name, descr });

// ---- Права ролей (матрица роль × экран) ----
export type Role = {
  key: string;
  name: string;
  ico: string | null;
  descr: string | null;
  hides_finance: number;
  is_admin: number;
};
export type ScreenRef = { key: string; name: string; sort: number };
export type Access = { roles: Role[]; screens: ScreenRef[]; matrix: Record<string, string[]> };

export const getAccess = () => apiGet<Access>('/api/admin/access');
export const setAccess = (role: string, screen: string, on: boolean) =>
  apiPost<{ ok: boolean }>('/api/admin/access', { role, screen, on });

export const createRole = (role: { key: string; name: string; ico?: string; descr?: string }) =>
  apiPost<{ ok: boolean; key: string }>('/api/admin/roles', role);
export const deleteRole = (key: string) =>
  apiSend<{ ok: boolean }>('DELETE', `/api/admin/roles/${key}`);
export const setRoleFlags = (key: string, flags: { hides_finance?: boolean; is_admin?: boolean }) =>
  apiPost<{ ok: boolean }>(`/api/admin/roles/${key}/flags`, flags);

// ---- Пользователи ----
export type ManagedUser = {
  id: number;
  email: string;
  name: string;
  role_key: string;
  active: number;
  is_demo: number;
  created_at?: string;
};

export const getUsers = () => apiGet<{ users: ManagedUser[] }>('/api/admin/users');
export const createUser = (email: string, name: string, role: string, password: string) =>
  apiPost<ManagedUser>('/api/admin/users', { email, name, role, password });

export const patchUser = (
  id: number,
  patch: { name?: string; role?: string; active?: boolean; password?: string },
) => apiSend<{ ok: boolean }>('PATCH', `/api/admin/users/${id}`, patch);

// ---- Журнал аудита ----
export type AuditEntry = {
  id: number;
  action: string;
  entity: string | null;
  entity_id: string | null;
  detail: string | null;
  at: string;
  user_name: string | null;
};

export const getAudit = (params?: { limit?: number; action?: string }) => {
  const qs = new URLSearchParams();
  if (params?.limit) qs.set('limit', String(params.limit));
  if (params?.action) qs.set('action', params.action);
  const q = qs.toString();
  return apiGet<{ log: AuditEntry[] }>('/api/admin/audit' + (q ? `?${q}` : ''));
};

// ---- Пресеты плана платежей ----
export type PresetDraftItem = { label: string; pct: number; due_offset: number };
export const getPayPresets = () => apiGet<{ presets: PayPreset[] }>('/api/admin/pay-presets');
export const createPayPreset = (name: string, items: PresetDraftItem[]) =>
  apiPost<{ id: number }>('/api/admin/pay-presets', { name, items });
export const updatePayPreset = (id: number, patch: { name?: string; items?: PresetDraftItem[] }) =>
  apiSend<{ ok: boolean }>('PATCH', `/api/admin/pay-presets/${id}`, patch);
export const deletePayPreset = (id: number) =>
  apiSend<{ ok: boolean }>('DELETE', `/api/admin/pay-presets/${id}`);

export type { PayPreset };
